<template>
  <div class="upload-subject">
      <van-field
            v-model="date"
            label="截止日期"
            input-align="right"
            readonly
        />
        <div class="main">
        <div class="title">
            <img src="@/assets/images/collection/subject_icon.png" />
            <span>课题名称（必填）</span>
        </div>
        <input placeholder="请输入课题名称" v-model="title"/>
        <div class="title">
            <img src="@/assets/images/collection/subject_icon.png" />
            <span>课题亚专业标签（必填）</span>
            <p class="tags" @click="changeFirstShowTag">{{showTag}}<van-icon name="arrow" class="arrow" /><van-icon v-if="upShowTag==''" name="add-o" class="arrow"  style="float:right;line-height: 19px" @click.stop="changeSecondShowTag"/></p>
            <p class="tags" @click="changeSecondShowTag" v-if="upShowTag">{{upShowTag}}<van-icon name="arrow" class="arrow" /><van-icon name="close" class="arrow"  style="float:right;line-height: 19px" @click.stop="clearTag"/></p>
        </div>
        <div class="title">
            <img src="@/assets/images/collection/subject_icon.png" />
            <span>课题内容（非必填）</span>
        </div>
        <textarea placeholder="请输入课题内容" rows="5" v-model="content"></textarea>
        </div>
        <div class="buttons">
            <button @click="onSave()" :disabled="disabled">保存</button>
        </div>
        <tag  :tags="tags" :f_tag_id="f_tag_id" :s_tag_id="s_tag_id" :show="show" @changeValue="changeFirstTag" ref="firstTag"></tag>
        <tag  :tags="tags" :f_tag_id="fup_tag_id" :s_tag_id="sup_tag_id" :show="upshow" @changeValue="changeSecondTag" ref="secondTag"></tag>
        <div class="back" @click="goBack()" style="bottom:90px;">
            <img src="@/assets/images/collection/go_back.png" />
      </div>
      <div class="back" @click="goIndex()">
            <img src="@/assets/images/collection/back_index.png" />
      </div>
  </div>
</template>

<script>
import {PersoanalUserInfo,topics,treeTags} from '../../config/interface.js'
import Tag from './components/tag.vue'
export default {
    components:{
        Tag
    },
    data(){
        return{
           date:'',
           title:'',
           content:'',
           id:0,
           topic_id:0,
           disabled:false,
           show:false,
           upshow:false,
           tags:[],

           active:0,
           subactive:0,
           showTag:'',
           upActive:0,
           upSubactive:0,
           editIndex:0,
           f_tag_id:0,
           s_tag_id:0,
           upShowTag:'',
           fup_tag_id:0,
           sup_tag_id:0
        }
    },
    created(){
        this.id=this.$route.query.meeting_id;
        this.topic_id=this.$route.query.id;
        if(this.topic_id){
            this.init();
        }
        this.getTags();
        this.getUserInfo();
        this.getDeadline();
        document.title="CEC官方";
        if(common.is_weixin()){
			common.wxShare('课题申报@中国血管论坛CEC2023','上报课题截止时间：2023年9月30日，欢迎您填写您的课题，谢谢您。','cdn.edstatic.com/203012120000/b20d0c68aad9dc88de3d7708dbf6c374/2022/07/9a6c31a0-d2f1-490c-8aa0-5942dc78e9dc.png');
		}
    },
    methods:{
        //得到用户信息
        getUserInfo(){
            const url=PersoanalUserInfo;
            let params={};
            const method='POST';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    localStorage.setItem('userInfo',JSON.stringify(data));
                    this.$store.dispatch('storageUserInfo',data);	
                    this.userInfo=data;
                    if(this.userInfo&&this.userInfo.mobile_status==1){
                        // let top=this.$refs.line.getBoundingClientRect().top;
                        // let bottom=this.$refs.line.getBoundingClientRect().bottom;
                    }
                    else{
                        common.toast('未绑定手机',1000,'fail',()=>{
                                this.$router.replace({
                                path:'/collection/login',
                                query:{url:window.location.href}
                        })
                        })	
                    }
                }
            })
        },
        getDeadline(){
            const url='webapi/meetings/'+this.id+'/collects';
            //post必填参数，title,content，可选参数code
            let params={};
            const method='GET';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    if(res.data.end_at){
                        this.date=res.data.end_at.split(" ")[0];
                    }
                }
            })
        },
        getTags(){
            const url=treeTags;
            //post必填参数，title,content，可选参数code
            let params={
                pid:1
            };
            const method='GET';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    this.tags=res.data;
                    if(this.topic_id){
                        
                    }
                    else{
                        this.changeFirstTag(0,0);
                    }
                }
            })
        },
        changeFirstShowTag(){
            this.$refs['firstTag'].changeShowFlag();
        },
        changeSecondShowTag(){
            this.$refs['secondTag'].changeShowFlag();
        },
        changeFirstTag(active,subactive){
            this.f_tag_id=this.tags[active].id;
            this.s_tag_id=this.tags[active].child[subactive].id;
            this.showTag=this.tags[active].name+'-'+this.tags[active].child[subactive].name;
        },
        changeSecondTag(active,subactive){
            this.fup_tag_id=this.tags[active].id;
            this.sup_tag_id=this.tags[active].child[subactive].id;
            this.upShowTag=this.tags[active].name+'-'+this.tags[active].child[subactive].name;
        },
        clearTag(){
            this.fup_tag_id=0;
            this.sup_tag_id=0;
            this.upShowTag='';
        },
        init(){
            let url=topics+"/"+this.topic_id;
            let method='GET';
            //post必填参数，title,content，可选参数code
            let params={};
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                     this.title=res.data.title;
                     this.content=res.data.content;
                     this.s_tag_id=res.data.s_tag_id;
                     this.f_tag_id=res.data.f_tag_id;
                     if(res.data.f_tag&&res.data.s_tag){
                         this.showTag=res.data.f_tag.name+'-'+res.data.s_tag.name;
                     }
                     this.sup_tag_id=res.data.sup_tag_id;
                     this.fup_tag_id=res.data.fup_tag_id;
                     if(res.data.fup_tag&&res.data.sup_tag){
                         this.upShowTag=res.data.fup_tag.name+'-'+res.data.sup_tag.name;
                     }
                }
            })
        },
        onSave(){
            this.disabled=true;
            let url=topics;
            let method='POST';
            if(this.topic_id){
                url=topics+"/"+this.topic_id;
                method='PUT';
            }
            //post必填参数，title,content，可选参数code
            let params={
                title:this.title,
                content:this.content,
                meeting_id:this.id,
                f_tag_id:this.f_tag_id,
                s_tag_id:this.s_tag_id,
                fup_tag_id:this.fup_tag_id,
                sup_tag_id:this.sup_tag_id,
            };
            fetch(url,params,method)
            .then((res)=>{
                this.disabled=false;
                if(res.code==0){
                     common.toast('保存成功！',1000,'success',()=>{
                            this.$router.push({
                            path:'/collection/subject',
                            query:{
                                id:this.id
                            }
                        })
                    })	
                }
            })
        },
        goIndex(){
            this.$router.push({
				path:'/collection/index',
                query:{
                    id:this.id
                }
			});
        },
        goBack(){
            this.$router.go(-1);
        },

    }

}
</script>

<style lang="scss" scoped>
.upload-subject{
    margin-bottom: 30px;
    font-size: 16px;
    .main{
        background: white;
        margin: 20px;
        padding: 0 20px 20px;
        .title{
            line-height: 50px;
            img{
                width: 18px;
                vertical-align: text-bottom;
            }
            .tags{
                color: #B01C06;
                padding-top: 0;
                margin-bottom: 15px;
                margin-left: 20px;
                line-height: 20px;
                .arrow{
                    color:#999999 !important;
                    vertical-align:middle;
                }
            }
        }
        input{
            background: #F7F7F7;
            width: calc(100% - 40px);
            line-height: 44px;
            border: 0;
            border-radius: 10px;
            padding: 0 20px;

        }
        textarea{
            background: #F7F7F7;
            width: calc(100% - 40px);
            line-height: 44px;
            border: 0;
            border-radius: 10px;
            padding: 0 20px;
        }
    }
    .choose-title{
        text-align: center;
            height:55px;
            font-size: 20px;
            line-height: 55px;
            background-color: #F5F6F7;
            font-weight: 440;
            // margin-top: -48px;
    }
    .tags{
        .left{
            width:35%;
            background-color: white;
            p{
                padding:17px 20px;
                //  line-height: 60px;
                color: #B5B5B5;
                font-size: 17px;
                background-color: #F5F6F7;
                
            }
            .active{
                color: #B01C06;
                font-size: 17px;
                background-color: white;

            }
        }
        .right{
            width: 65%;
            padding-left: 20px;
            background-color: white;
            p{
                height: 60px;
                line-height: 60px;
                color: black;
                font-size: 17px;
                border-bottom: 1px solid #F9F9F9;
            }
            .active{
                color: #B01C06;
                font-size: 18px;
                img{
                    height: 30px;
                    float: right;
                    margin-top: 15px;
                    margin-right: 20px;
                }
            }
        }
    
    }
    .buttons{
        margin: 20px;
        text-align: center;
        button{
            width: 45%;
            height: 40px;
            color: white;
            border: 1px solid #B01C06;
            border-radius: 5px;
            background: #B01C06;
        }
    }
    .back{
        position: fixed;
        right: 0;
        bottom: 30px;
        img{
            height: 40px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/Contributions/upload.vue